import { createSelector } from "reselect";
import * as fromCoinPrice from "./coinPrices/selectors";
import * as fromAuth from "./auth/selectors";
import * as fromUIState from "./uiState/selectors";
import * as fromLabs from "./labs/selectors";
import * as fromTixWix from "./tixwix/selectors";
import * as fromContests from "./contests/selectors";

export const selectAuth = fromAuth.selectAuth;
export const selectWallet = fromAuth.selectWallet;
export const selectWallets = fromAuth.selectWallets;
export const selectAuthField = fromAuth.selectAuthField;

export const getMuted = fromUIState.getMuted;
export const getAssetType = fromUIState.getAssetType;
export const getTimeStampTimer = fromUIState.getTimeStampTimer;
// export const getTickerType = fromUIState.getTickerType;
export const getCookiesAccepted = fromUIState.getCookiesAccepted;

export const getCoinPrices = fromCoinPrice.getCoinPrices;
export const selectCoinPrice = fromCoinPrice.selectCoinPrice;

export const getAllPositions = (state) =>
  fromTixWix.getAllPositions(state.tixwix);
export const selectMarketType = fromTixWix.selectMarketType;
export const selectTixwixDate = fromTixWix.selectTixwixDate;
export const selectTixwixTrading = fromTixWix.selectTixwixTrading;
export const selectTixwixMarkets = fromTixWix.selectTixwixMarkets;
export const selectMarketsExpirate = fromTixWix.selectMarketsExpirate;
export const selectTixwixPriceGoing = fromTixWix.selectTixwixPriceGoing;

export const getSelectedCoin = fromContests.getSelectedCoin;
export const getSelectedDuration = fromContests.getSelectedDuration;

export const getExchanges = fromLabs.getExchanges;

export const getIdAndWallet = createSelector(
  getAssetType,
  selectAuth,
  (assetType, authState) => {
    if (authState === false || !Object.keys(authState)?.length) return {};

    const { accounts = [], token, id } = authState;
    const totalBalance = accounts.reduce((all, item) => {
      if (assetType === item.assetType) {
        all += item.balance;
      }
      return all;
    }, 0);

    const walletPending = accounts.reduce((all, item) => {
      if (assetType === item.assetType) {
        all += item.pendingWithdrawals;
      }
      return all;
    }, 0);

    return {
      token,
      id,
      totalBalance,
      walletPending,
      assetType,
    };
  }
);

export const getSocketValue = createSelector(
  getCoinPrices,
  getSelectedCoin,
  (coinPrices, selectedCoin) => coinPrices[selectedCoin]
);
